import "./ProfileSetupFourthScreen.css";
import bannerBcIcon from "../../assets/images/profile-setup-founder-header.png";
import bannerImage from "../../assets/images/profile-setup-non-member-bg.svg";
import rightArrowIcon from "../../assets/images/profile-setup-right-button-arrow.svg";
import { useLogout } from "services/LogoutProvider";
import { WEB_LINK } from "utils/strings";

const ProfileSetupFourthScreen = () => {
  const { handleLogout } = useLogout();

  const handleDeepDiveClick = () => {
    window.open(WEB_LINK.WORKSPACE_APP, "_blank", "noopener,noreferrer");
    handleLogout();
  };

  const handleExploreSabeClick = () => {
    window.open(WEB_LINK.SABEHUB_LINK, "_blank", "noopener,noreferrer");
    handleLogout();
  };

  return (
    <div className="wms-mobile-container">
      <div className="profile-setup-fourth-screen-container">
        <img
          src={bannerBcIcon}
          alt="profile-setup-banner"
          className="header-image"
        />
        <img src={bannerImage} alt="profile-setup-bg" className="bg-image" />
        <div className="deep-dive-button" onClick={handleDeepDiveClick}>
          <span className="title">Deep Dive Into Execution Space</span>
          <span className="sub-title">
            3 Focus Zone to turn Ideas into Executions
          </span>
        </div>
        <div className="explore-sabehub-button" onClick={handleExploreSabeClick}>
          <div className="sub-container">
            <span className="title">
              Explore <span style={{ color: "#FF6B35" }}>SabeHub</span>
            </span>
            <span className="sub-title">
              3rd Space for Founders & Remote Workers
            </span>
          </div>
          <img
            src={rightArrowIcon}
            alt="profile-setup-right-arrow"
            className="right-arrow"
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileSetupFourthScreen;
